import * as React from 'react';
import { Checkbox as MuiCheckbox } from '@mui/material';
import { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import { Theme, css } from '@emotion/react';
import SvgIconCheckbox from './IconCheckbox';
import SvgIconCheckboxChecked from './IconCheckboxChecked';
import SvgIconCheckboxIndetermined from './IconCheckboxIndetermined';

export interface CheckboxProps
  extends Pick<MuiCheckboxProps, Exclude<keyof MuiCheckboxProps, 'color'>> {
  color?: 'primary';
}
const root = ({ colors, spacing }: Theme) => css`
  color: ${colors.borderBase};
  padding: ${spacing(0.75)}px;
`;

/**
 * Use `Checkbox` for rendering a checkbox, see stories for more complete examples
 *
 * ```js
 * import { Checkbox } from 'ui';
 * ```
 *
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
export const Checkbox: React.FunctionComponent<React.PropsWithChildren<CheckboxProps>> = ({
  color = 'primary',
  ...rest
}) => {
  return (
    <MuiCheckbox
      css={root}
      indeterminateIcon={<SvgIconCheckboxIndetermined />}
      checkedIcon={<SvgIconCheckboxChecked />}
      icon={<SvgIconCheckbox />}
      color={color}
      {...rest}
    />
  );
};

export default Checkbox;
